function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect, useMemo, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { requiredValidation } from 'validators';
import { TextField, Typography } from 'seagull';
import { InitialDiscount } from "../BillClientModal.types";
import { getTotal } from "../BillClientModal.utils";
import { BillChargeClientApprovalCallout } from "../Callouts/Callouts";
import { ServiceTemplateInput } from "../../common/ServiceTemplateInput/ServiceTemplateInput";
import DiscountTextField from "../../DiscountTextField";
import { serviceCostModel, serviceTemplateModel } from "../../../models";
import { utils } from "../../../utils";
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import styles from "../BillClientModal.module.scss";
import BillingItemNote from "../BillingNote/BillingItemNote";
import BillTableItem from "../BillTableItem/BillTableItem";
import { getTableInfo, validateGreaterThan0 } from "./BillChargeTableItem.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function BillChargeTableItem(props) {
  const {
    invoiceDateInfo,
    actionColumn,
    itemIndex,
    chargeItem,
    relationship
  } = props;
  const {
    trigger,
    control,
    resetField,
    watch,
    setValue
  } = useFormContext();
  const [selectedService, setSelectedService] = useState(null);
  const [issueDate] = watch(['issueDate']);
  const {
    serviceTemplateId,
    quantity,
    rate,
    discount
  } = chargeItem.charge;
  const hasService = !!serviceTemplateId;
  const {
    columnDefs,
    headerItems
  } = useMemo(() => getTableInfo(discount), [discount]);
  const total = useMemo(() => getTotal(quantity, rate, serviceTemplateId, discount), [quantity, rate, serviceTemplateId, discount]);
  useEffect(() => {
    // The error in discount field depends on total amount so we trigger change detection when total changes.
    trigger(["items.".concat(itemIndex, ".charge.discount")]);
  }, [total]);
  const applyServiceChange = service => {
    setSelectedService(service || null);
    if (service) {
      const newQuantity = serviceTemplateModel.isFixedPrice(service.cost) ? '1' : '';
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      setValue("items.".concat(itemIndex, ".charge.quantity"), newQuantity);
      setValue("items.".concat(itemIndex, ".charge.rate"), serviceTemplateModel.price(service).abs().toString(), {
        shouldValidate: true
      });
      const discount = serviceTemplateModel.discount(service);
      const newDiscount = discount ? {
        type: discount.type(),
        amount: discount.amount().toString()
      } : InitialDiscount;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      setValue("items.".concat(itemIndex, ".charge.discount"), newDiscount);
    } else {
      resetField("items.".concat(itemIndex, ".charge.quantity"));
      resetField("items.".concat(itemIndex, ".charge.rate"));
      setValue("items.".concat(itemIndex, ".charge.discount"), InitialDiscount);
    }
  };
  const rowItems = [{
    value: /*#__PURE__*/_jsx(Controller, {
      control: control,
      name: "items.".concat(itemIndex, ".charge.serviceTemplateId"),
      rules: {
        required: true
      },
      render: renderProps => /*#__PURE__*/_jsx(ServiceTemplateInput, {
        testId: "add-charge-".concat(itemIndex, "-service-selector"),
        relationship: relationship,
        menuWidth: 350,
        renderProps: renderProps,
        applyServiceChange: applyServiceChange
      })
    })
  }, {
    value: /*#__PURE__*/_jsx(Controller, {
      control: control,
      name: "items.".concat(itemIndex, ".charge.quantity"),
      rules: {
        validate: validateGreaterThan0
      },
      render: renderProps => /*#__PURE__*/_jsx(TextField, _objectSpread({
        collapseHelperText: false,
        isMoney: true,
        size: "small",
        "data-testid": "add-charge-quantity-".concat(itemIndex),
        inputProps: {
          min: 0,
          className: styles.amountCell
        },
        disabled: !hasService
      }, connectControllerToTextField(renderProps, {
        noHelperText: true
      })))
    })
  }, {
    value: /*#__PURE__*/_jsx(Controller, {
      control: control,
      name: "items.".concat(itemIndex, ".charge.rate"),
      rules: requiredValidation(true),
      render: renderProps => /*#__PURE__*/_jsxs("div", {
        className: styles.rate,
        children: [/*#__PURE__*/_jsx(TextField, _objectSpread({
          collapseHelperText: false,
          isMoney: true,
          size: "small",
          "data-testid": "add-charge-".concat(itemIndex, "-rate"),
          inputProps: {
            min: 0,
            className: styles.amountCell
          },
          disabled: !hasService
        }, connectControllerToTextField(renderProps, {
          noHelperText: true
        }))), selectedService && serviceTemplateModel.isVariablePrice(selectedService.cost) && /*#__PURE__*/_jsxs(Typography, {
          ellipsis: true,
          className: styles.units,
          variant: "paragraph2",
          skin: "secondary",
          "data-testid": "add-charge-".concat(itemIndex, "-units"),
          children: ["/", serviceCostModel.formattedUnitName(selectedService.cost)]
        })]
      })
    })
  }, {
    value: /*#__PURE__*/_jsx(Controller, {
      control: control,
      name: "items.".concat(itemIndex, ".charge.discount"),
      rules: {
        validate: value => value && total != null && total.lessThan(0) ? 'The discount cannot be greater than the rate' : true
      },
      render: renderProps => /*#__PURE__*/_jsx("div", {
        className: styles.discount,
        children: /*#__PURE__*/_jsx(DiscountTextField, _objectSpread(_objectSpread({
          size: "small",
          "data-testid": "add-charge-".concat(itemIndex, "-discount"),
          disabled: !hasService,
          inputProps: {
            className: styles.amountCell
          }
        }, connectControllerToTextField(renderProps)), {}, {
          value: discount,
          onChange: _ref => {
            let {
              type,
              amount
            } = _ref;
            const didTypeChange = type !== discount.type;
            if (didTypeChange) {
              renderProps.field.onChange({
                type,
                amount: ''
              });
            } else {
              renderProps.field.onChange({
                type,
                amount
              });
            }
          }
        }))
      })
    })
  }, {
    value: null
  }, {
    value: total != null ? /*#__PURE__*/_jsx(Typography, {
      align: "right",
      "data-testid": "add-charge-total",
      skin: total.lessThan(0) ? 'error' : 'standard',
      children: utils.formatDollarAmount(total)
    }) : null
  }];
  return /*#__PURE__*/_jsx(BillTableItem, {
    columnDefs: columnDefs,
    headerItems: headerItems,
    rowItems: rowItems,
    headerTestId: "add-charge-table-header",
    actionColumn: actionColumn,
    footer: /*#__PURE__*/_jsxs("div", {
      className: styles.noteAndCalloutsContainer,
      children: [/*#__PURE__*/_jsx(BillingItemNote, {
        testid: "manual-bill-note-".concat(itemIndex),
        name: "items.".concat(itemIndex, ".note")
      }), /*#__PURE__*/_jsx(BillChargeClientApprovalCallout, {
        issueDate: issueDate,
        invoiceDateInfo: invoiceDateInfo
      })]
    })
  });
}